import React, {Component} from 'react';
import {withRouter, Link} from 'react-router-dom';
import Messages from "../../subscribers/Messages";
import WorkArea from "../../subscribers/WorkArea";

class OverView extends Component {

    componentDidMount() {
        const script = document.createElement("script");
        script.src = process.env.PUBLIC_URL+"/js/core.js";
        script.async = true;
        document.body.appendChild(script);
    }

    render() {
        const {pathname} = this.props.location;

        if (pathname.includes("/admin/blog")) {
            return (
                <WorkArea
                    list={"blog_list"}
                    single={"articles"}
                    url={"admin/blog"}
                />
            );
        }

        if (pathname.includes("/admin/portfolio")) {
            return (
                <WorkArea
                    list={"portfolio_list"}
                    single={"works"}
                    url={"admin/portfolio"}
                />
            );
        }

        if (pathname === "/admin/contact") {
            return (<Messages/>);
        }

        return (
            <div className="container py-12">
                <div className="grid lightbox" data-columns="4" data-gutter="5" data-cell-ratio="5/4">

                    <Link to="admin/blog" className="portfolio-item wide tall" data-background="img/blog.jpg">
                        <figcaption>
                            <h5 className="item-title">
                                Blog
                            </h5>
                        </figcaption>
                    </Link>

                    <Link to="admin/portfolio" className="portfolio-item wide" data-background="img/works.jpg">
                        <figcaption>
                            <h5 className="item-title">
                                Portfolio
                            </h5>
                        </figcaption>
                    </Link>

                    <Link to="admin/contact" className="portfolio-item" data-background="img/contact.jpg">
                        <figcaption>
                            <h5 className="item-title">
                                Mensajes
                            </h5>
                        </figcaption>
                    </Link>

                </div>
            </div>
        );
    }
}

export default withRouter(OverView);


// WEBPACK FOOTER //
// ./src/admin/components/dashboard/Overview.js